import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

export function StructuredData() {
  const { t, i18n } = useTranslation()

  useEffect(() => {
    const data = {
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      name: 'Pierre Costruzioni S.r.l.',
      description: t('home.meta.description'),
      url: 'https://pierrecostruzioni.it',
      telephone: String(t('contact.phone')).replace(/\s/g, ''),
      email: t('contact.email'),
      address: {
        '@type': 'PostalAddress',
        streetAddress: t('contact.address'),
        addressLocality: 'Credera Rubbiano',
        postalCode: '26010',
        addressRegion: 'CR',
        addressCountry: i18n.language === 'it' ? 'IT' : 'IT',
      },
      foundingDate: '2000',
      sameAs: [],
    }

    const id = 'structured-data-local-business'
    let script = document.getElementById(id) as HTMLScriptElement | null
    if (!script) {
      script = document.createElement('script')
      script.id = id
      script.type = 'application/ld+json'
      document.head.appendChild(script)
    }
    script.textContent = JSON.stringify(data)

    return () => {
      script?.remove()
    }
  }, [t, i18n.language])

  return null
}
